import { Inject, Injectable } from '@angular/core';
import { AppService } from '../../app.service';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VmDropConfigService {

  private _apiBaseUrl: string = '';

  public constructor(private appService: AppService, public http: HttpClient, @Inject('API_BASE_URL') baseurl: string) {
    this._apiBaseUrl = baseurl;
  }

  public getVMDropConfigs = (status: boolean): Observable<any> => {
    const apipath: string = 'vmdrop/creditor?IsVMDropEnabled='+status;
    const fullPath: string = this._apiBaseUrl + apipath;
    const options = this.appService.getHttpHeaderOptions();

    return this.http.get<any>(fullPath, options);
  }

  
  public getVMDropIntegration = (cid: string): Observable<any> => {
    const apipath: string = 'vmdrop/vmdropintegration/'+cid;
    const fullPath: string = this._apiBaseUrl + apipath;
    const options = this.appService.getHttpHeaderOptions();

    return this.http.get<any>(fullPath, options);
  }

  public updateVmDropStatus = (CreditorId: string, IsVMDropEnabled: number): Observable<any> => {
    const apipath: string = 'vmdrop/vmdrop-status';
    const fullPath: string = this._apiBaseUrl + apipath;
    const options = this.appService.getHttpHeaderOptions();
    const params: any = { CreditorId: +CreditorId, IsVMDropEnabled: IsVMDropEnabled};

    return this.http.put<any>(fullPath, params, options);
  }

  public updateVmDropForm = (data: any): Observable<any> => {
    const apipath: string = 'vmdrop/update-vmdropintegration';
    const fullPath: string = this._apiBaseUrl + apipath;
    const options = this.appService.getHttpHeaderOptions();
    const params: any = data;

    return this.http.put<any>(fullPath, params, options);
  }

  public createVmDropForm = (data: any): Observable<any> => {
    const apipath: string = 'vmdrop/create-vmdropintegration';
    const fullPath: string = this._apiBaseUrl + apipath;
    const options = this.appService.getHttpHeaderOptions();
    const params: any = data;

    return this.http.post<any>(fullPath, params, options);
  }
}